/**
 * Parse the raw text out of an allocation-cell input. Accepts dot-decimal
 * and Estonian comma-decimal forms (`12.5` / `12,5`). Mixed separators or
 * any non-numeric character (beyond a single leading sign) are rejected.
 *
 * Returns the parsed positive number, or `null` for "invalid or non-
 * positive — caller should clear the cell to 0". The caller decides the
 * unit (percent vs hours) based on its own showHours toggle.
 */
export function parseAllocInput(raw: string): number | null {
  const trimmed = raw.trim();
  const normalized = trimmed.replace(",", ".");
  const hasMixed = trimmed.includes(",") && trimmed.includes(".");
  const validShape = /^-?\d*\.?\d*$/.test(normalized);
  if (hasMixed || !validShape) return null;
  const num = Number.parseFloat(normalized);
  if (!Number.isFinite(num) || num <= 0) return null;
  return num;
}
